@if (isDebugMode) {
    <span class="material-symbols-outlined debug-button"  (click)="debugPopover.toggle($event)">
        bug_report
    </span>
    <p-popover #debugPopover [dismissable]="false">
        <div class="close-debug-popover" (click)="debugPopover.hide()">
            <span class="material-symbols-outlined">
                close
            </span>
        </div>
        <div>RoomCode: {{rate.room.roomCode}}</div>
        <div>RateCode: {{rate.rate.rateCode}}</div>
        <div>CancelPolicyCode: {{rate.rate.cancelPolicyCode}}</div>
        <div>mandatoryDepositType: {{rate.rate.mandatoryDepositType}}</div>
        <div>Price: {{rate.totalPriceForStayWithTaxes}}</div>
        <div>PriceBeforeDiscount (originalPrice): {{rate.totalOriginalPrice}}</div>
        <div>Currency: {{rate.currency}}</div>
        <!-- {{rate|json}} -->
    </p-popover>
}
